import * as yup from 'yup'

export const authenticateSchema = yup.object().shape({
    email: yup
    .string().email().required(),
    password: yup.string().required(),
  })